/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

import { AnalyticsReporterConfiguration } from '../configuration/AnalyticsReporterConfiguration';
import { Provider } from '../Provider';
import { Player } from '@quickplay/player-interface';
import { Constants as ConvivaConstants } from '@convivainc/conviva-js-coresdk';
import { NewRelicAnalyticsReporterConfiguration } from '../configuration/NewRelicAnalyticsReporterConfiguration';

export function getProvider(configuration: AnalyticsReporterConfiguration): Provider {
  if (!configuration || typeof configuration !== 'object') {
    return Provider.UNKNOWN;
  }

  if ('configId' in configuration) {
    return Provider.DATAZOOM;
  }

  if ('customerKey' in configuration) {
    return Provider.CONVIVA;
  }

  if ('accountCode' in configuration) {
    return Provider.NPAW;
  }

  if ((configuration as NewRelicAnalyticsReporterConfiguration).provider === Provider.NEWRELIC) {
    return Provider.NEWRELIC;
  }

  if ((configuration as { provider?: Provider }).provider === Provider.GODAVARI) {
    return Provider.GODAVARI;
  }

  return Provider.UNKNOWN;
}

/**
 * Returns whether playback is live, VOD or unknown.
 * @param player the player instance
 */
export function isLive(
  player?: Player,
): (typeof ConvivaConstants.StreamType)[keyof typeof ConvivaConstants.StreamType] {
  if (!player) {
    return ConvivaConstants.StreamType.UNKNOWN;
  }

  if (player.isLive) {
    return ConvivaConstants.StreamType.LIVE;
  }

  return ConvivaConstants.StreamType.VOD;
}
